import useGlobalContext from "../context/GlobalContext"

const Footer = ({ contain }) => {
  const {changeCursor} = useGlobalContext()
  return (
    <footer data-scroll-section className={contain ? "container" : ""}>
      <p className="uppercase">COPYRIGHT © 2022 Pixie Autumn</p>
      <p className="uppercase">
        website made by &nbsp;
        <a
          onMouseEnter={() => changeCursor("hovered")}
          onMouseLeave={() => changeCursor("")}
          href="https://leul-michael.netlify.app/"
          target="_blank"
          rel="noreferrer"
        >
          Leu_l Michael
        </a>
      </p>
    </footer>
  )
}

export default Footer
